<template>
  <div class="work">
    <h2>Relevant Experience</h2>
    <p class="highlight-text">Please complete each section below providing details of your relevant experience.</p>
    <!-- Form -->
    <b-form>
      <!-- Rapport -->
      <b-form-group
        :label="generateLabel(recruit.workExamples.workExampleRapport, 'A confident approach to building rapport and forging exceptional relationships')"
      >
        <b-form-textarea
          :value="recruit.workExamples.workExampleRapport"
          @input="handleInput('workExampleRapport', $event, true, true)"
          :class="{
            'is-valid': !$v.recruit.workExamples.workExampleRapport.$error && recruit.workExamples.workExampleRapport,
            'is-invalid': $v.recruit.workExamples.workExampleRapport.$error
          }"
        ></b-form-textarea>
      </b-form-group>
      <!-- sales -->
      <b-form-group
        :label="generateLabel(recruit.workExamples.workExampleSale, 'Ideally successful experience of working in a target based sales role; otherwise the drive to succeed in an environment designed to reward excellence with proven persuasive and influencing skills and a results orientated nature')"
      >
        <b-form-textarea
          :value="recruit.workExamples.workExampleSale"
          @input="handleInput('workExampleSale', $event, true, true)"
          :class="{
            'is-valid': !$v.recruit.workExamples.workExampleSale.$error && recruit.workExamples.workExampleSale,
            'is-invalid': $v.recruit.workExamples.workExampleSale.$error
          }"
        ></b-form-textarea>
      </b-form-group>
      <!-- Geography -->
      <b-form-group
        :label="generateLabel(recruit.workExamples.workExampleGeography, 'A strong worldwide geographical awareness with first hand travel being advantageous')"
      >
        <b-form-textarea
          :value="recruit.workExamples.workExampleGeography"
          @input="handleInput('workExampleGeography', $event, true, true)"
          :class="{
            'is-valid': !$v.recruit.workExamples.workExampleGeography.$error && recruit.workExamples.workExampleGeography,
            'is-invalid': $v.recruit.workExamples.workExampleGeography.$error
          }"
        ></b-form-textarea>
      </b-form-group>
      <!-- Tech -->
      <b-form-group
        :label="generateLabel(recruit.workExamples.workExampleTech, 'Previous experience of working in a busy, pressurized office environment, competent PC and keyboard skills with the ability to effectively and quickly manage multiple software applications simultaneously')"
      >
        <b-form-textarea
          :value="recruit.workExamples.workExampleTech"
          @input="handleInput('workExampleTech', $event, true, true)"
          :class="{
            'is-valid': !$v.recruit.workExamples.workExampleTech.$error && recruit.workExamples.workExampleTech,
            'is-invalid': $v.recruit.workExamples.workExampleTech.$error
          }"
        ></b-form-textarea>
      </b-form-group>
      <!-- Education -->
      <b-form-group
        :label="generateLabel(recruit.workExamples.workExampleEducation, 'A good standard of education, ideally to degree level, and the ability to multi task and quickly interpret a large volume of complex information whilst communicating effectively with clients over the phone and face to face')"
      >
        <b-form-textarea
          :value="recruit.workExamples.workExampleEducation"
          @input="handleInput('workExampleEducation', $event, true, true)"
          :class="{
            'is-valid': !$v.recruit.workExamples.workExampleEducation.$error && recruit.workExamples.workExampleEducation,
            'is-invalid': $v.recruit.workExamples.workExampleEducation.$error
          }"
        ></b-form-textarea>
      </b-form-group>
      <!-- Management -->
      <b-form-group
        :label="generateLabel(recruit.workExamples.workExampleManagement, 'Strong organisational and time management skills, a close attention to detail and the ability to thrive in a regimented corporate working environment')"
      >
        <b-form-textarea
          :value="recruit.workExamples.workExampleManagement"
          @input="handleInput('workExampleManagement', $event, true, true)"
          :class="{
            'is-valid': !$v.recruit.workExamples.workExampleManagement.$error && recruit.workExamples.workExampleManagement,
            'is-invalid': $v.recruit.workExamples.workExampleManagement.$error
          }"
        ></b-form-textarea>
      </b-form-group>
      <!-- <BtnMain @btnClicked="handleProgress" text="Save and progress" btnClass="progress-btn" variant="dark" /> -->
    </b-form>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { updateForm } from '../../helpers/index'
// import BtnMain from '../../components/BtnMain'
import { required, minLength } from 'vuelidate/lib/validators'
export default {
  components: {
    // BtnMain
  },
  computed: {
    ...mapState({recruit: state => state.authStore.recruit}),
    ...mapGetters({
      getRecruit: 'authStore/getRecruit',
      getSectionOpen: 'authStore/getSectionOpen'
    })
  },
  mounted () {
    this.$v.$touch()
  },
  updated () {
    // Pass validation status to vuex
    const validationData = {
      section: 'work',
      status: !this.$v.recruit.$invalid
    }
    this.updateApplicationCompleteAction(validationData)
  },
  methods: {
    ...mapActions({
      updateRecruitAction: 'authStore/updateRecruitAction',
      sectionOpenAction: 'authStore/sectionOpenAction',
      updateBelfastSelectedAction: 'authStore/updateBelfastSelectedAction',
      updateApplicationCompleteAction: 'authStore/updateApplicationCompleteAction'
    }),
    handleInput (input, e, nested, required) {
      // handle nested input
      const nestedItem = {
        category: 'workExamples',
        input
      }
      this.updateForm(nestedItem, e, nested)
      // If field is required run veulidate validation - to apply classes to input not to prevent user from saving
      if (required) {
        this.$v.recruit.workExamples[input].$touch()
      }
    },
    updateForm,
    generateLabel(field, label){
      if (field.length < 300){
        label += ', (min 300 characters)'
      } 
      label += '.'
      return label
    }
  },
  validations: {
    recruit: {
      workExamples: {
        workExampleRapport: {
          required: required,
          minLengthValue: minLength(300)
        },
        workExampleSale: {
          required: required,
          minLengthValue: minLength(300)
        },
        workExampleGeography: {
          required: required,
          minLengthValue: minLength(300)
        },
        workExampleTech: {
          required: required,
          minLengthValue: minLength(300)
        },
        workExampleEducation: {
          required: required,
          minLengthValue: minLength(300)
        },
        workExampleManagement: {
          required: required,
          minLengthValue: minLength(300)
        }
      }
    }
  }
}
</script>

<style scoped>

</style>